<script lang="ts">
  import type { Sponsors } from "$types";
  import { lazyLoad } from "$lib/actions/lazyLoad";
  import { is_date_between } from "$lib/dates";
  import { get_pattern } from "$lib/utilities";
  import DiscountCode from "./DiscountCode.svelte";
  export let margin_bottom: boolean = false;
  export let sponsors: Sponsors[];
</script>

<section class:margin_bottom>
  <div class="sponsorGrid">
    {#each sponsors as sponsor (sponsor.key)}
      <div class="sponsor" target="_blank" rel="noopener noreferrer">
        <a
          target="_blank"
          href="/sponsors/{sponsor.slug}"
          rel="noopener noreferrer"
          class="logo"
        >
          <img
            alt={sponsor.name}
            src="/lazy.gif"
            use:lazyLoad={`https://backend.craftroulette.live/assets/${sponsor.logo}?key=submission-preview`}
          />
        </a>
        <div class="meta" style:background-image={get_pattern()}>
          <a
            target="_blank"
            href="/sponsors/{sponsor.slug}"
            rel="noopener noreferrer"
            class="name">{sponsor.name}</a
          >
          <div class="tags">
            {#if sponsor.current}
              <span class="tag current">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                  ><rect width="256" height="256" fill="none" /><path
                    d="M135.34,28.9l23.23,55.36a8,8,0,0,0,6.67,4.88l59.46,5.14a8,8,0,0,1,4.54,14.07L184.13,147.7a8.08,8.08,0,0,0-2.54,7.89l13.52,58.54a8,8,0,0,1-11.89,8.69l-51.1-31a7.93,7.93,0,0,0-8.24,0l-51.1,31a8,8,0,0,1-11.89-8.69l13.52-58.54a8.08,8.08,0,0,0-2.54-7.89L26.76,108.35A8,8,0,0,1,31.3,94.28l59.46-5.14a8,8,0,0,0,6.67-4.88L120.66,28.9A8,8,0,0,1,135.34,28.9Z"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="24"
                  /></svg
                > Active</span
              >
            {/if}
            {#if sponsor.episodes?.length}
              <span class="tag">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                  ><rect width="256" height="256" fill="none" /><rect
                    x="28"
                    y="84"
                    width="160"
                    height="128"
                    rx="8"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="24"
                  /><path
                    d="M68,84V52a8,8,0,0,1,8-8H220a8,8,0,0,1,8,8V164a8,8,0,0,1-8,8H188"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="24"
                  /><line
                    x1="28"
                    y1="124"
                    x2="188"
                    y2="124"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="24"
                  /></svg
                >

                {sponsor.episodes.length} Episodes</span
              >
            {/if}

            {#if sponsor.affiliate}
              <span class="tag">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                  ><rect width="256" height="256" fill="none" /><path
                    d="M127.88,196l-5.94,5.94a48,48,0,0,1-67.88-67.88L78.17,110A48,48,0,0,1,144,108"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="24"
                  /><path
                    d="M128.12,60l5.94-5.94a48,48,0,0,1,67.88,67.88l-24.11,24.11A48,48,0,0,1,112,148"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="24"
                  /></svg
                >
                Affiliate Link
              </span>
            {/if}

            {#if (sponsor.code && !sponsor.code_start && !sponsor.code_end) || (sponsor.code && is_date_between(sponsor.code_start, sponsor.code_end))}
              <span class="tag">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                  ><rect width="256" height="256" fill="none" /><path
                    d="M42.34,138.34A8,8,0,0,1,40,132.69V40h92.69a8,8,0,0,1,5.65,2.34l99.32,99.32a8,8,0,0,1,0,11.31L153,237.66a8,8,0,0,1-11.31,0Z"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="24"
                  /></svg
                >
                Discount Code
              </span>
            {/if}
          </div>
        </div>
        <DiscountCode {sponsor} />
      </div>
    {/each}
  </div>
</section>

<style>
.margin_bottom .sponsorGrid {
  margin-bottom: 2rem;
}

.sponsorGrid {
  position: relative;
  z-index: 5;
  display: grid;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
  grid-template-columns: repeat(3, 1fr);
}
@media (max-width: 1000px) {
  .sponsorGrid {
    grid-template-columns: 1fr 1fr;
    padding: 1rem;
  }
}
@media (max-width: 500px) {
  .sponsorGrid {
    grid-template-columns: 1fr;
  }
}

.sponsor {
  border-radius: 1rem;
  font-weight: normal;
  text-decoration: none;
  max-width: 100%;
  text-align: center;
  background: white;
  box-shadow: var(--shadow);
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
.sponsor .meta {
  color: var(--title);
  padding: 1.5rem;
  flex-grow: 1;
}
.sponsor .meta .tags {
  padding-top: 0.5rem;
  font-size: 0.8rem;
}
.sponsor .meta .tags .tag {
  padding: 0.3rem 0.5rem;
  margin: 0.25rem;
  font-weight: bold;
  color: white;
  background: var(--secondary);
  white-space: nowrap;
  display: inline-flex;
  border-radius: 0.25rem;
  align-items: center;
  gap: 0.5rem;
}
.sponsor .meta .tags .tag svg {
  width: 1rem;
  height: 1rem;
}
.sponsor .meta .tags .tag.current {
  border: none;
  background: var(--primary);
  color: white;
}
.sponsor .meta .name {
  font-size: 1rem;
  font-weight: bold;
  background: transparent;
  text-decoration: none;
  text-transform: capitalize;
  color: var(--title);
}
.sponsor .meta .name:hover {
  color: var(--primary);
}
.sponsor .logo {
  padding: 1rem 2rem;
  border-bottom: 1px solid var(--dots);
  height: 12rem;
  display: grid;
  place-content: center;
  background: transparent;
}
.sponsor .logo img {
  max-width: 100%;
  max-height: 10rem;
}

@media (max-width: 600px) {
  .sponsorGrid {
    grid-template-columns: 1fr;
    font-size: 1rem;
  }
}
</style>
